import {
  dashboardColor,
  globeColor,
  archiveColor,
  customizationsColor,
  teamMembersColor,
  managerColor,
  postmasterColor,
  delegateColor,
  importsColor,
  migrationsColor,
  etliveColor,
  registerColor,
  reportColor,
  cartColor,
  supportColor,
  prices,
  restore,
  emailDelivery,
  users,
  suppressionList,
} from "Icons/index";
import _ from "lodash";
import QboxmailApi from "../../qboxmailApi";

function showWHMCSInvoice(action = "show_invoice") {
  let win = window.open("about:blank", "_blank");
  win.focus();
  const api = new QboxmailApi({ useCookie: true });
  return api
    .generateWHMCSUrl(action)
    .then((r) => {
      win.location.replace(r.resources[0].url);
    })
    .catch((response) => {
      console.log("error generating whmcs invoice", response);
    });
}

function goToWHMCSTicketPage(customer, router) {
  if (customer.plan === "trial") {
    router.push("/support");
    return;
  }

  let win = window.open("about:blank", "_blank");
  win.focus();
  const api = new QboxmailApi({ useCookie: true });
  return api
    .generateWHMCSUrl("get_support_url")
    .then((r) => {
      win.location.replace(r.resources[0].url);
    })
    .catch((response) => {
      // redirect to login page
      console.log("error generating whmcs login, redirecting to login page", response);
      win.location.replace("https://www.qboxmail.it/manager/clientarea.php");
    });
}

export default (customer, router, isDelivery = false) => {
  if (isDelivery) {
    return [
      { category: "", links: [{ path: "/delivery", label: "sidebar.item.emailDelivery", icon: emailDelivery }] },
      {
        category: "sidebar.category.management",
        links: [
          { path: "/delivery/accounts", label: "sidebar.item.emailDelivery.accounts", icon: users },
          { path: "/delivery/domains", label: "sidebar.item.domains", icon: globeColor },
          {
            path: "/delivery/suppression-list",
            label: "sidebar.item.emailDelivery.suppressionList",
            icon: suppressionList,
          },
          {
            label: "sidebar.item.support",
            icon: supportColor,
            action: () => goToWHMCSTicketPage(customer, router),
          },
        ],
      },
      {
        category: "sidebar.category.analysis",

        links: [{ path: "/delivery/tracemail", label: "sidebar.item.etlive", icon: etliveColor }],
      },
    ];
  }

  const isResellerOrWholesale = customer.is_reseller || customer.is_wholesale;
  const hasOrder = customer.orders.length > 0;
  const hasUnpaidOrder = customer.orders.length === 1 && customer.orders[0]?.status !== "paid";
  const hasAnnuallyOrder = customer.orders?.[0]?.billing_cycle === "annually";

  return _.compact([
    {
      category: "",
      links: [
        { path: "/home", label: "sidebar.item.dashboard", icon: dashboardColor },
        { path: "/prices", label: "sidebar.item.prices", icon: prices, newFeature: false },
        hasOrder &&
          hasUnpaidOrder &&
          !IS_APP && {
            action: () => showWHMCSInvoice(),
            label: "sidebar.item.orderslist",
            icon: cartColor,
          },

        hasOrder &&
          !hasUnpaidOrder &&
          hasAnnuallyOrder &&
          !IS_APP && { path: "/orders", label: "sidebar.item.orders", icon: cartColor },

        // show whmcs invoice for the monthly
        hasOrder &&
          !hasUnpaidOrder &&
          !hasAnnuallyOrder &&
          !IS_APP && {
            action: () => showWHMCSInvoice("get_invoices"),
            label: "sidebar.item.orders",
            icon: cartColor,
          },

        !hasOrder && !IS_APP && { path: "/orders/new#1", label: "sidebar.item.orders", icon: cartColor },
      ],
    },
    {
      category: "sidebar.category.management",
      stepName: "step-management",
      links: [
        { path: "/domains", label: "sidebar.item.domains", icon: globeColor },
        { path: "/archive", label: "sidebar.item.archive", icon: archiveColor },
        { path: "/customizations", label: "sidebar.item.customizations", icon: customizationsColor },
        { path: "/mtm_requests", label: "sidebar.item.mtm_requests", icon: restore },
      ],
    },

    {
      category: "sidebar.category.roles",
      stepName: "step-roles",
      links: [
        { path: "/team_members", label: "sidebar.item.teamMembers", icon: teamMembersColor },
        {
          path: "/managers",
          label: "sidebar.item.managers",
          icon: managerColor,
          hide: !isResellerOrWholesale,
        },
        { path: "/postmasters", label: "sidebar.item.postmasters", icon: postmasterColor },
        { path: "/delegates", label: "sidebar.item.delegates", icon: delegateColor },
      ],
    },
    {
      category: "sidebar.category.importsMigrations",
      links: [
        { path: "/imports", label: "sidebar.item.imports", icon: importsColor },
        { path: "/migrations", label: "sidebar.item.migrations", icon: migrationsColor },
      ],
    },
    {
      category: "sidebar.category.analysis",
      stepName: "step-analysis",
      links: [
        { path: "/tracemail", label: "sidebar.item.etlive", icon: etliveColor },
        { path: "/audits", label: "sidebar.item.auditLogs", icon: registerColor },
        { path: "/reports", label: "sidebar.item.reports", icon: reportColor },

        {
          label: "sidebar.item.support",
          icon: supportColor,
          action: () => goToWHMCSTicketPage(customer, router),
        },
      ],
    },
  ]);
};
